import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {BaseComponent} from "./pages/base.component";
import {BaseRoutingModule} from "./base-routing.module";
import {RouterModule} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import { FeedbackModule } from "../feedback/feedback.module";

@NgModule({
  declarations: [
    BaseComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BaseRoutingModule,
    MatIconModule,
    FeedbackModule
  ],
})
export class BaseModule {
  constructor() { }
}
